import { curry } from "ramda";

export const datesOverlap = curry((start1, end1, start2, end2) => {
  return (
    new Date(start1).getTime() <= new Date(end2).getTime() &&
    new Date(end1).getTime() >= new Date(start2).getTime()
  );
});
